import React from "react";
import { useSearchParams } from "react-router";
import i18n from "src/i18n/config";

import { showErrorToast } from "@shared/toasts/Toasts";

type PolicyId = string | null;
type UseCurrentPolicy = (policies: API.PolicyViewModel[]) => [PolicyId, (value: PolicyId) => void];

export const policyNameExists = (policies: API.PolicyViewModel[], name: string): boolean =>
    policies.some((policy) => policy.name?.trim().toLowerCase() === name.trim().toLowerCase());

export const useCurrentPolicy: UseCurrentPolicy = (policies) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const paramPolicyId = searchParams.get("policyId");
    const [id, setId] = React.useState<PolicyId>(paramPolicyId || policies[0]?.id || null);

    const setCurrentPolicyId = (value: PolicyId) => {
        setId(value);
        setSearchParams(value ? { policyId: value } : {}, { replace: true });
    };

    const warnAboutUnreachableUrlPolicy = () => {
        if (!paramPolicyId) {
            return;
        }
        const policyExists = policies.find((policy) => policy.id === paramPolicyId);
        if (policyExists) {
            return;
        }

        showErrorToast(i18n.t("pages:policiesPage.toast.dontHaveAccessToPolicy"));
        const fallbackPolicyId = policies[0]?.id ?? null;
        setCurrentPolicyId(fallbackPolicyId);
    };

    React.useEffect(() => {
        warnAboutUnreachableUrlPolicy();
    }, []);

    return [id, setCurrentPolicyId];
};
